import { localStorageKeys } from 'Config';

/**
 * Aktif dili Masterpass SDK'sının beklediği BCP-47 biçiminde döndürür.
 *
 * ⚠️ Eski MFS SDK'sı `'tur'` / `'eng'` bekliyordu. Yeni SDK'nın `setLanguage()`
 * metodu değerin tire içermesini şart koşuyor; içermiyorsa SESSİZCE `'en-US'`e
 * düşürüyor. Yani eski `'tur'` değeri gönderilirse arayüz Türkçe kalsa bile
 * Masterpass'ten gelen mesajlar ve SMS'ler İngilizce olur.
 */
const getActiveLanguageForMasterPass = (): 'tr-TR' | 'en-US' => {
  const language = localStorage.getItem(localStorageKeys.i18nextLng);
  return language === 'en' ? 'en-US' : 'tr-TR';
};

export default getActiveLanguageForMasterPass;
